/**
 * @type {import("@sentry/nextjs").BrowserOptions}
 */
export const sentryConfig = {
    dsn: process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN || "https://f896e3cb7e18a7ffb19a3aa26da539e8@o41183.ingest.us.sentry.io/4506988802736128",
    environment: process.env.NEXT_PUBLIC_TURNR_ENV || process.env.NODE_ENV,
    enabled: process.env.NODE_ENV !== "development",
    tracesSampleRate: 1,
    ignoreErrors: [
        "ResizeObserver loop limit exceeded", // Caused by ResizeObserver. The error comes from a library and is noy dangerous but annoying
        "ResizeObserver loop completed with undelivered notifications", // Caused by ResizeObserver. The error comes from a library and is noy dangerous but annoying
        "Non-Error promise rejection captured", // Because of google analytics promise rejections with non exception errors being thrown
        "Can't find variable: logMutedMessage",
        "The operation is insecure",
    ],
};
